<template>
  <base-label v-if="autoLabel.length" class="mt-0 truncate">{{ autoLabel }}</base-label>
  <base-label v-else class="mt-0 truncate">
    {{ element.pivot.label || 'Repeater' }} Item {{ itemId }}
  </base-label>
</template>
<script>
  import BaseLabel from '../Form/BaseLabel.vue';
  export default {
    name: 'RepeaterLabel',
    components: {
      BaseLabel,
    },
    props: {
      data: {
        type: Object
      },
      element: {
        type: Object
      },
      itemId: {
        type: Number
      },
      defaultRepeaterLabel: {
        type: String,
        default: '',
      }
    },
    computed: {
      autoLabel() {
        const strings = [];
        if (this.defaultRepeaterLabel.length) {
          strings.push(this.defaultRepeaterLabel);
        }
        this.element.children.forEach(el => {
          if (el.datatype === 'string' && !String(el.pivot.label).toLowerCase().includes('deprecated') && !String(el.pivot.label).toLowerCase().includes('hidden') && !String(el.pivot.label).toLowerCase().includes('old cms id')) {
            const strVal = this.data[el.pivot.column || el.pivot.variable];
            if (el.name === 'Dynamic Select') {
              // skip
            } else if (strVal) {
              strings.push(strVal);
            }
          } else if (el.name === 'Text with Tag' && !String(el.pivot.label).toLowerCase().includes('deprecated') && !String(el.pivot.label).toLowerCase().includes('hidden')) {
            const val = this.data[el.pivot.column || el.pivot.variable];
            if (val && val.content) {
              strings.push(val.content);
            }
          }
        });
        return strings.join(' - ');
      }
    },
    mounted() {

    }
  }
</script>
